<template>

    <button @click="capture" :disabled="isCapturing">
      <b v-if="isCapturing" class="loading">
        <svg class="spinner" viewBox="0 0 50 50">
          <circle style="color: blue;" class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>
        </svg>
        Đang chụp...
      </b>
      <b v-else>Chụp ảnh</b>
    </button>

</template>

<script setup>
import { ref } from 'vue'
import html2canvas from 'html2canvas'

const isCapturing = ref(false)

const capture = async () => {
  isCapturing.value = true

  // 1. Thêm CSS tạm để bỏ box-shadow
  const styleTag = document.createElement('style')
  styleTag.id = 'temporary-remove-shadow'
  styleTag.innerHTML = `* { box-shadow: unset !important; .nb-q{ height: auto; } }`
  document.head.appendChild(styleTag)

  try {
    // 2. Chụp canvas
    const canvas = await html2canvas(document.documentElement, {
      useCORS: true,
      backgroundColor: '#fff',
      scrollY: -window.scrollY
    })

    // 3. Xuất blob để tương thích tốt với iOS
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error("Không thể tạo ảnh từ canvas")
        return
      }

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'screenshot.png'
      link.click()

      setTimeout(() => URL.revokeObjectURL(link.href), 100)
    }, 'image/png')
  } catch (err) {
    console.error('Lỗi khi chụp ảnh:', err)
  } finally {
    // 4. Gỡ CSS tạm và tắt loading
    styleTag.remove()
    isCapturing.value = false
  }
}
</script>

<style scoped>
.loading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.spinner {
  animation: spin 1s linear infinite;
  height: 20px;
  width: 20px;
}

button{
    border: none;
    padding: 0;
    box-shadow: unset;
    width: 100%;
    background: none;
    height: 100%;
}
button b{
    font-weight: normal;
}

.spinner .path {
  stroke: #007BFF; /* xanh bootstrap */
  stroke-linecap: round;
  stroke-dasharray: 126;
  stroke-dashoffset: 31.5;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
